/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextAlignRightIcon64Regular = forwardRef('TextAlignRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M9.5 11a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 0 0 0-3h-45Z" }),
        React.createElement("path", { d: "M28 25.5a1.5 1.5 0 0 1 1.5-1.5h25a1.5 1.5 0 0 1 0 3h-25a1.5 1.5 0 0 1-1.5-1.5Z" }),
        React.createElement("path", { d: "M9.5 37a1.5 1.5 0 0 0 0 3h45a1.5 1.5 0 0 0 0-3h-45Z" }),
        React.createElement("path", { d: "M29.5 50a1.5 1.5 0 0 0 0 3h25a1.5 1.5 0 0 0 0-3h-25Z" })));
});
